import { render, staticRenderFns } from "./gankao.vue?vue&type=template&id=5e6837cb&scoped=true&"
import script from "./gankao.vue?vue&type=script&lang=js&"
export * from "./gankao.vue?vue&type=script&lang=js&"
import style0 from "./gankao.vue?vue&type=style&index=0&id=5e6837cb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6837cb",
  null
  
)

export default component.exports